// @flow

import { PureComponent } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';

import DisplayText from '../Text/DisplayText';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const SecondLine = styled.div`
  padding-top: 10px;
`;

type Props = {
  date: Date
};

type State = {
  date: moment | null
};

export default class DatePresenter extends PureComponent<Props, State> {
  componentDidMount() {
    const date = moment(this.props.date);
    this.setState({ date });
    this.updateDate(date);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  state = {
    date: null
  };
  timeoutId: TimeoutID;

  updateDate(dateToDisplay: moment) {
    const date = moment(dateToDisplay);
    const nextDay = moment(date).add(1, 'days');
    nextDay.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const timeLeftTillNextDay = moment.duration(nextDay.diff(date));

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.setState({ date: nextDay });
      this.updateDate(nextDay);
    }, timeLeftTillNextDay.asMilliseconds());
  }

  render() {
    if (!this.state.date) {
      return null;
    }

    return (
      <Container>
        <DisplayText fontSize="20px" opacity={0.65}>
          {this.state.date.format('dddd')}
        </DisplayText>
        <SecondLine>
          <DisplayText fontSize="20px" opacity={0.65}>
            {((this.state.date: any): moment).format('MMMM DD')}
          </DisplayText>
        </SecondLine>
      </Container>
    );
  }
}

DatePresenter.propTypes = {
  date: PropTypes.instanceOf(Date)
};
